/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialPreview.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PREVIEW_PDF } from "../graphql";
import { VApplication } from "../../../application";
import { toHeaderCase } from "js-convert-case";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICredentialPreviewMethods extends IPluginMethodMap {
  getCredentialPreview(args: any): Promise<any>;
}

export interface CredentialPreviewProps {
  templateId: string;
  formData: any;
  evidence: any;
  credentialLogo: string;
  credentialName: string;
  isWalletRegistered:boolean;
}

export class CredentialPreviewService implements IAgentPlugin {
  readonly methods: ICredentialPreviewMethods;

  constructor() {
    this.methods = {
      getCredentialPreview: this.getCredentialPreview.bind(this),
    };
  }

  async getCredentialPreview(args: CredentialPreviewProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PREVIEW_PDF,
          variables: {
            credentialTemplateId: args?.templateId,
            credentialContent: args?.formData,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getPreviewPdf) {
          console.log(`preview pdf`, res?.data?.getPreviewPdf);
          return {
            title: args?.credentialName,
            logoSrc: args?.credentialLogo,
            carouselItems: this.getFormatCarousel(
              res?.data?.getPreviewPdf,
              args
            ),
            credential: this.getFormatCredential(args),
            isWalletRegistered:args?.isWalletRegistered
          };
          // return {
          //   ...res?.data?.getCredentialSchema,
          //   credentialLogo:res?.data?.getCredentialSchema?.logo,
          //   credentialDescription:res?.data?.getCredentialSchema?.description,
          //   credentialFields:res?.data?.getCredentialSchema?.jsonFormat?.credential,
          //   submitButtonLabel:config?.submitButtonTitle,
          //   credentialName: this.formatName(
          //     res?.data?.getCredentialSchema?.name
          //   ),
          //   templateId: res?.data?.getCredentialSchema?.id,
          // };
        }
      }
      // const res = await axios.post(config.url, {
      //   credentialSubject: { ...(args || {}) },
      // });
      // if (res?.data) {
      //   const payload: any = {
      //     images: [],
      //     meta: this.getFormattedMeta(args),
      //     actions: config?.actions,
      //   };
      //   payload.images.push({
      //     original: `${config?.imgFormat?.format},${res?.data?.image}`,
      //     thumbnail: `${config?.imgFormat?.format},${res?.data?.image}`,
      //     thumbnailHeight: config?.imgFormat?.height,
      //     thumbnailClass: config?.imgFormat?.class,
      //   });

      //   return payload;
      // }
    } catch (err: any) {
      return {
        title: args?.credentialName,
        logoSrc: args?.credentialLogo,
        carouselItems: this.getFormatCarousel(null, args),
        credential: this.getFormatCredential(args),
        isWalletRegistered:args?.isWalletRegistered
      };
    }
  }

  private getFormatCredential(args: any) {
    const _attributeData: any = [];
    const { formData } = args;
    Array.isArray(formData) &&
      formData.forEach((item) => {
        if (!Array.isArray(item?.value)) {
         // && !(typeof(item?.value) === 'object')
        _attributeData.push({
          label: toHeaderCase(item?.key ?? ""),
          value: item?.value,
        });
      }
      // if(typeof(item?.value) === 'object'){
      //   _attributeData.push({
      //     label:toHeaderCase(item?.key),
      //     value:item?.value?.base64,
      //   })
      // }
      });
      
    return _attributeData;
  }

  private getFormatCarousel(previewPdf: any, args: any) {
    console.log(`evidence`, args?.evidence);
    const { evidence, credentialLogo, credentialName } = args;
    let formatted: any = [];
    if (previewPdf?.pdf) {
      formatted.push({
        type: "pdf",
        poster: credentialLogo,
        src: `data:application/pdf;base64,${previewPdf?.pdf}`,
        title: credentialName,
      });
    }
    Array.isArray(evidence) &&
      evidence.length > 0 &&
      evidence.forEach((item) => {
        if (item?.type === "pdf") {
          formatted.push({
            type: "pdf",
            poster: config?.pdfPoster,
            src: `data:application/pdf;base64,${item?.base64}`,
          });
        } else if (
          item?.type === "image/png" ||
          item?.type === "image/jpg" ||
          item?.type === "image/jpeg"
        ) {
          formatted.push({
            type: "img",
            poster: config?.imgPoster,
            src: item?.base64,
          });
        }
      });
    return formatted;
  }

  private getFormattedMeta(formData: any) {
    console.log(`formData private`, formData);
    let _tableData: any = [];
    for (const [key, value] of Object.entries(formData)) {
      _tableData.push({
        key: key,
        value: value,
      });
    }
    return _tableData;
  }
}
